module.exports = __webpack_public_path__ + "static/media/17.be88741c.png";